

import React from 'react';
import { UIViewEnum } from '../../common/enums/UIViewEnum';
import { AdministrationList } from '../../components/administration-list/AdministrationList';
import { ContentView } from '../../components/content-view/ContentView';
import ContextualAppBar from '../../components/contextual-app-bar/ContextualAppBar';
import { ViewOptionStateEnum } from '../../components/contextual-app-bar/ViewOptionStateEnum';
import { useRouteContext } from '../../hooks/use-route-context/UseRouteContext';
import { useAvailableAdminViews } from '../../queries/available-views/UseAvailableAdminViews';
import { useQueryNotifications } from '../../queries/UseQueryNotifications';
import { IRoute, routes } from '../../routes/routes';
import { isMobile, isTablet } from 'react-device-detect';


export default function AdministrationView() {


    const routeContext = useRouteContext();
    const isPhone = isMobile && !isTablet;

    const {data} = useQueryNotifications(useAvailableAdminViews)({
        groupID: routeContext.groupID as number
    });


    const adminRoutes = data?.reduce((result: IRoute[], currentValue) => { 
        return result.concat(routes.filter(o => o.parentViewID === currentValue && ((isPhone && o.allowMobile) || !isPhone)))
    }, []);

    // make sure we get a distinct list for the parent admin ID
    const adminViews = adminRoutes?.map(o => o.parentViewID as UIViewEnum)
                        .filter((value, index, self) => self.indexOf(value) === index);

    //console.log(`adminViews: ${JSON.stringify(adminViews)}`)

    return (
        <ContentView>
            <ContextualAppBar 
                hideBreadcrumb={true}
                //actions={state.actions} 
                viewOptionState={ViewOptionStateEnum.Hidden}
                //onExecuteAction={onExecuteAction} 
            />

            <AdministrationList viewIDs={adminViews ?? []} />
            
        </ContentView>
    );
  }
